module.exports = __webpack_public_path__ + "img/vn-dejun2.ea7d348b.png";